module.exports = __webpack_public_path__ + "img/icon-generic-generic8.18d47a56.svg";